(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.property-details-fund-blocked', [
    'pp.widgets-templates',
    'pp.filters.numbers'
]);

ngModule.component('ppPropertyDetailsFundBlocked', {
    templateUrl: 'widgets/_angular/property-details-fund-blocked/property-details-fund-blocked.tpl.html',
    bindings: {
        property: '<',
        user: '<'
    },
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);